import React from 'react';
import type { PendingAttachment } from '../../constants/fileUploadConstants';
import { AttachmentChip } from './AttachmentChip';

export interface AttachmentChipListProps {
  attachments: PendingAttachment[];
  onRemove: (localId: string) => void;
  onRetry: (localId: string) => void;
  /** Additional classes for the wrapper — defaults suit rendering inside the input box. */
  className?: string;
}

/**
 * Wrapping row of attachment chips rendered inside the composer input box,
 * above the textarea (ChatGPT-style). Renders nothing when there are no attachments.
 */
export const AttachmentChipList: React.FC<AttachmentChipListProps> = ({
  attachments,
  onRemove,
  onRetry,
  className,
}) => {
  if (attachments.length === 0) return null;

  return (
    <div
      className={`flex flex-wrap gap-1.5 pb-2 border-b border-border-default ${className ?? ''}`}
      role="list"
      aria-label="Attached files"
    >
      {attachments.map(att => (
        <AttachmentChip
          key={att.localId}
          attachment={att}
          onRemove={onRemove}
          onRetry={onRetry}
        />
      ))}
    </div>
  );
};
